import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Program } from "@/components/landing/Program";
import { WhoItServes } from "@/components/landing/WhoItServes";
import { PreLaunch } from "@/components/landing/PreLaunch";
import { InterestForm } from "@/components/landing/InterestForm";
import { Footer } from "@/components/landing/Footer";

export default function HomePage() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#0A0A0A] text-[#F5F5F5]" data-testid="home-page">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Program />
        <WhoItServes />
        <PreLaunch />
        <InterestForm />
      </main>
      <Footer />
    </div>
  );
}
